<div class="container-fluid" *ngIf="spinnerService.getSpinnerState() | async">
    <ngx-spinner
      bdColor="rgba(0, 0, 0, 0.8)"
      size="medium"
      color="#fff"
      type="ball-clip-rotate-pulse"
    >
    </ngx-spinner>
  </div>